import { render, staticRenderFns } from "./CommunityPostsCard3.vue?vue&type=template&id=44539d14&"
import script from "./CommunityPostsCard3.vue?vue&type=script&lang=js&"
export * from "./CommunityPostsCard3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports